// 九畴云市 · 数据飞轮 / AI / AI 应用服务商数据

// 数据飞轮
export const dataFlywheel = [
  { label: '商品数据', detail: '商品数字化后的结构化信息。' },
  { label: '交易数据', detail: '订单、支付、履约数据。' },
  { label: '消费数据', detail: '真实消费行为与权益核销。' },
  { label: '用户数据', detail: '消费者、云社员画像与关系。' },
  { label: '服务数据', detail: '服务预约、履约、评价。' },
  { label: '产业数据', detail: '供应链、产地、库存数据。' },
  { label: 'AI 分析', detail: 'TOMA 对多源数据进行智能分析。' },
  { label: '需求预测', detail: '预测县域消费需求趋势。' },
  { label: '供应链优化', detail: '优化供给结构与库存。' },
  { label: '商品优化', detail: '优化商品组合与结构。' },
  { label: '再次交易', detail: '驱动下一轮交易，形成飞轮。' },
];

// TOMA AI 对不同角色的价值
export const tomaRoles = [
  { role: '对消费者', question: '「我想吃什么？」', answer: 'AI 帮我找。', icon: 'ri-user-smile-line' },
  { role: '对云社员', question: '「什么商品值得卖？」', answer: 'AI 帮我选。', icon: 'ri-user-search-line' },
  { role: '对云店长', question: '「今天应该经营什么？」', answer: 'AI 帮我分析。', icon: 'ri-store-2-line' },
  { role: '对供应链', question: '「什么商品正在增长？」', answer: 'AI 帮我判断。', icon: 'ri-truck-line' },
  { role: '对平台', question: '「哪个县域正在发生消费变化？」', answer: 'AI 帮我识别。', icon: 'ri-radar-line' },
];

// AI 应用服务商四大能力
export const aiServiceCapabilities = [
  {
    no: '01',
    icon: 'ri-compass-3-line',
    name: '咨询规划',
    desc: '县域数字经济顶层设计与落地规划。',
  },
  {
    no: '02',
    icon: 'ri-tools-line',
    name: '交付实施',
    desc: 'TOMA 智能体、数字货架、系统集成、设备连接。',
    items: ['TOMA 智能体', '数字货架', '系统集成', '设备连接'],
  },
  {
    no: '03',
    icon: 'ri-settings-3-line',
    name: '运营管理',
    desc: '平台运营、清分对账、数据看板与持续运维。',
  },
  {
    no: '04',
    icon: 'ri-shield-check-line',
    name: '安全治理',
    desc: '数据安全、合规治理、风控与边界管理。',
  },
];